
export const LeadInformation = (props:any) => {
    const{uuid,first_name,last_name,email,phone} = props
  return (
    <div className="col-sm-6 px-4">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Uuid:</th>
            <td>{uuid}</td>
          </tr>
          <tr>
            <th scope="row">First Name:</th>
            <td>{first_name}</td>
          </tr>
          <tr>
            <th scope="row">Last Name:</th>
            <td>{last_name}</td>
          </tr>
          <tr>
            <th scope="row">Email:</th>
            <td>{email}</td>
          </tr>
          <tr>
            <th scope="row">Phone:</th>
            <td>{phone}</td>
          </tr>
          </tbody>
      </table>
    </div>
  )
}
